"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = DaysNameHeader;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var DAYS_NAME = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

function DaysNameHeader() {
  return _react["default"].createElement("div", {
    className: "calendar__vertical-header"
  }, _react["default"].createElement("table", {
    className: "calendar__vertical-day-names"
  }, _react["default"].createElement("thead", {
    className: "calendar__row"
  }, _react["default"].createElement("tr", null, DAYS_NAME.map(function (dayName) {
    return _react["default"].createElement("th", {
      className: "calendar__day-name",
      key: dayName
    }, dayName);
  })))));
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@honeyguide/components/dist/components/DateRangePicker/DaysNameHeader.js
// module id = 1453
// module chunks = 0